interface StatCardProps {
  title: string
  value: string | number
  icon: string
  color?: 'primary' | 'success' | 'warning' | 'danger'
  subtitle?: string
  isLoading?: boolean
}

export const StatCard = ({
  title,
  value,
  icon,
  color = 'primary',
  subtitle,
  isLoading = false,
}: StatCardProps) => {
  const colorClasses = {
    primary: 'bg-primary/10',
    success: 'bg-success/10',
    warning: 'bg-warning/10',
    danger: 'bg-danger/10',
  }

  return (
    <div className="bg-white dark:bg-gray-800 rounded-card shadow p-6">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">
            {title}
          </p>
          {isLoading ? (
            <div className="h-8 w-24 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
          ) : (
            <>
              <p className="text-2xl font-bold text-gray-900 dark:text-white">
                {value}
              </p>
              {subtitle && (
                <p className="text-xs text-gray-500 dark:text-gray-500 mt-1">
                  {subtitle}
                </p>
              )}
            </>
          )}
        </div>
        <div className={`w-12 h-12 ${colorClasses[color]} rounded-full flex items-center justify-center flex-shrink-0`}>
          <span className="text-2xl">{icon}</span>
        </div>
      </div>
    </div>
  )
}

export default StatCard
